require('./angular-route');
module.exports = 'ngRoute';



//////////////////
// WEBPACK FOOTER
// ./~/angular-route/index.js
// module id = 131
// module chunks = 0